import { Http, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { Observable } from 'rxjs';
import { constant } from 'app/app.constants';
import { TypeOfFileEnum } from 'app/core/enums/batch-status.enum';

@Injectable()
export class EdiFilesService extends ParentService {
  constructor(private http: Http) {
    super();
  }

  getFiles(
    fileTrackingNumber?: number,
    beginDate?: string,
    endDate?: string
  ): Observable<any> {
    return this.http
      .get(
        `${constant.URL_GET_EDI_FILES}/${fileTrackingNumber}/${beginDate}/${endDate}`,
        this.getHeader()
      )
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  downloadEdiFile({
    ediFileId,
    force = false,
    body = null,
    isReplacement = null,
  }: {
    ediFileId: number;
    force?: boolean;
    body?: any;
    isReplacement?: any;
  }): Observable<any> {
    let url = ``;

    if (force) {
      url += `force=${force}`;
    }
    if (isReplacement) {
      const param = `isReplacement=${
        isReplacement === TypeOfFileEnum.replacement.toString()
      }`;
      url.length > 0 ? (url += `&${param}`) : (url += `${param}`);
    }
    if (url.length > 0) {
      url = `?${url}`;
    }

    return this.http
      .post(
        `${constant.URL_IMPORT_EDI_FILE}/${ediFileId}${url}`,
        body,
        this.getFileHeaders()
      )
      .map((res: any) => res)
      .catch((error: any) => Observable.throw(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/edi-files/edi-files.service.ts